export type SurfaceTokens = {
  page: string
  default: string
  strong: string
  hover: string
  inverse: string
  overlay: string
  muted: string
}

export type BorderTokens = {
  subtle: string
  default: string
  strong: string
}

export type GrayScale = {
  0: string
  3: string
  8: string
  12: string
  16: string
  40: string
  56: string
  64: string
  80: string
  100: string
}

export type StatusTone = {
  background: string
  text: string
}

export type StatusTokens = {
  neutral: StatusTone
  danger: StatusTone
  warning: StatusTone
  success: StatusTone
}

export type TextRoles = {
  inverse: string
  onPrimary: string
  primary?: string
  secondary?: string
  disabled?: string
}

export type ColorRoles = {
  surface: SurfaceTokens
  border: BorderTokens
  text: TextRoles
  status: StatusTokens
}

export const lightColorRoles = {
  surface: {
    page: '#F8F9F9',
    default: '#FFFFFF',
    strong: '#EDEEEE',
    hover: '#F8F9F9',
    inverse: '#1E2026',
    overlay: 'rgba(30, 32, 38, 0.6)',
    muted: 'rgba(219, 219, 220, 0.6)',
  },
  border: {
    subtle: '#EDEEEE',
    default: '#DBDBDC',
    strong: '#A5A6A8',
  },
  text: {
    inverse: '#FFFFFF',
    onPrimary: '#FFFFFF',
  },
  status: {
    neutral: { background: '#EDEEEE', text: '#6F7074' },
    danger: { background: '#FDE9E9', text: '#A21616' },
    warning: { background: '#FDF1E6', text: '#A15305' },
    success: { background: '#E6F7EC', text: '#00782F' },
  },
} satisfies ColorRoles
